<!--工时明细-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
       :toolBar="{ hidden: true}"
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
      <template #taskState="{row}">
          <!--任务状态 D待审批，N已分配，Y已完成，T回退 -->
        <el-tag v-if="row.taskState === 'D'">待审批</el-tag>
        <el-tag v-if="row.taskState === 'N'">已分配</el-tag>
        <el-tag v-if="row.taskState === 'Y'">已完成</el-tag>
        <el-tag v-if="row.taskState === 'T'">回退</el-tag>
      </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { parseTime } from "@/utils";
import { downloadExcel } from "@/api/bill/ProjectPlan";
export default {
  name: "Manhour",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin],
  data() {
    return {
      tableHead: [
        {
          label: "项目名称",
          prop: "projectName",
           query: {
            type: "input"
          }
        },
        {
          label: "任务数",
          prop: "totalTask",
        },
        // {
        //   label: "用户",
        //   prop: "userName",
        //    query: {
        //     type: "input"
        //   }
        // },
        // {
        //   label: "任务时间",
        //   prop: "plannedStartTime",
        //   formatter: this.formatter,
        //    query: {
        //     type: "datetimerange",
        //     key: "plannedStartTime"
        //   }
        // },
        {
          label: "任务工时",
          prop: "totalNature"
        },
        {
          label: "实际工时",
          prop: "totalActual"
        },
        //   {
        //   label: "状态",
        //   prop: "taskState",
        //   slot: "taskState",
        // },
      ],
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    formatter(val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
      // 导出
      downloadExcel() {
        downloadExcel('/bizTaskDecomposition/exportCollect',this._query,'工时汇总')
      },
    dataTableBeforeInit() {
      this._url = "/bizTaskDecomposition/collect";
      const params = { page: this.page, size: this.offset,}
      this._params = Object.assign(params,this._query);
      return true;
    },
    dynamicSearch() {},
  }
};
</script>

<style scoped lang="scss">
</style>
